// No-op module returned when server-side code imports CSS/SCSS files.
// CSS is handled by Vite on the client side — the server just ignores it.
module.exports = {};
